import { TransportationPayment } from "@/features/transportations/transportation-payment.type";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useFetcher from "@/utils/use-fetcher";
import { Price, StoredObject } from "@/features/types";

export interface CreateTransportationPaymentParameter {
  agencyId: number;
  transportationId: number;
}

export interface CreateTransportationPaymentRequest {
  issuedOn: Date;
  file: Pick<StoredObject, "id" | "name"> | null;
  amount: Price;
  isRemitted: boolean;
  remittedOn: Date | null;
}

export interface CreateTransportationPaymentResponse extends TransportationPayment {}

const templateUrl = `/agencies/:agencyId/transportations/:transportationId/transportation-payments`;

export const createTransportationPaymentKey: YWRKey<CreateTransportationPaymentParameter> = {
  url: (parameter) => calcUrl(templateUrl, parameter),
  method: "post",
};

export default function useCreateTransportationPayment() {
  const fetcher = useFetcher<
    CreateTransportationPaymentRequest,
    CreateTransportationPaymentResponse
  >();
  return useYWR(createTransportationPaymentKey, fetcher);
}
